// extracted by mini-css-extract-plugin
export default {"tabs":"NewOrderEmployee_tabs__-QawH","selected":"NewOrderEmployee_selected__7K8XN","previous":"NewOrderEmployee_previous__3fVRs"};